/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { get, defaultsDeep } from 'lodash';
import {
  Text,
  File,
  DateField,
  withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import { Icon } from '../../ui/Icon';
import { cardCss, titleCss, iconCss, dateCss, fileCss } from './index.styles';
import { fieldHasValue } from '../../../utils/sitecore';
import Spacer from '../../ui/Spacer';
import defaultData from './defaultData';
import { SafePureComponent } from '../../../utils/SafePureComponent';

class DownloadCard extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const fields = defaultsDeep(props.fields, defaultData);

    const lng = get(props, 'sitecoreContext.language', '');

    const isEditing = get(props, 'sitecoreContext.pageEditing', false);

    const renderCard = () =>
      isEditing || (fieldHasValue(fields.Title) && fieldHasValue(fields.File));

    return (
      <Spacer>
        {renderCard() && (
          <div css={cardCss}>
            <File
              // Add style on edition mode to fix an issue where date and title are not editable.
              css={[fileCss, isEditing && { zIndex: -1 }]}
              field={fields.File}
              download={`${fields.Title.value}.pdf`}
              rel="noopener noreferrer"
              target="_blank"
            />
            <Icon customCss={iconCss} name="pdf" />
            <p css={dateCss}>
              {(isEditing || fieldHasValue(fields.Date)) && (
                <DateField
                  field={fields.Date}
                  render={date =>
                    date.toLocaleString(lng, {
                      month: 'long',
                      year: 'numeric',
                    })
                  }
                />
              )}
            </p>
            <h3 css={titleCss}>
              <Text field={fields.Title} />
            </h3>
          </div>
        )}
      </Spacer>
    );
  }
}

DownloadCard.displayName = 'DownloadCard';

DownloadCard.defaultProps = { fields: defaultData };

DownloadCard.propTypes = {
  Title: PropTypes.shape({
    value: PropTypes.string,
  }),
  Date: PropTypes.shape({
    value: PropTypes.string,
  }),
  File: PropTypes.shape({
    value: PropTypes.object,
  }),
};

export default withSitecoreContext()(DownloadCard);
